import * as yup from 'yup';

import {
	PASSWORD_REQUIRED,
	USERNAME_REQUIRED,
} from './schema-errors';

export const signInSchema = yup.object({
	username: yup.string().required(USERNAME_REQUIRED),
	password: yup.string().required(PASSWORD_REQUIRED),
});
